import { render, staticRenderFns } from "./prescriptionImage.vue?vue&type=template&id=cc33dd0c&scoped=true"
import script from "./prescriptionImage.vue?vue&type=script&lang=js"
export * from "./prescriptionImage.vue?vue&type=script&lang=js"
import style0 from "./prescriptionImage.vue?vue&type=style&index=0&id=cc33dd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc33dd0c",
  null
  
)

export default component.exports